export default __webpack_public_path__ + "static/media/g13.5c385d3a.webp";